export default __webpack_public_path__ + "static/media/ast-798151.3fc440cf.jpg";